//CSS
import "../../Components/Page/Page.css";

//React
import React from "react";
import Footer from "../../Components/Footer/FooterSmall";
import Header2 from "../../Components/Header2/Header2";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

interface ScrollPageProps {
  index: number;
  children: React.ReactNode;
  sections?: SectionItem[];
}

export interface SectionItem {
  label: string;   // what shows in UI
  id: string;      // what you navigate / scroll to
}

const ScrollPage: React.FC<ScrollPageProps> = ({ index, children, sections = []}) => {
  const location = useLocation();

  useEffect(() => {
    if(sections.length != 0){
      const elementId = sections[index].id;
      const el = elementId ? document.getElementById(elementId) : null;
      if (el) {
        requestAnimationFrame(() => {
          window.scrollTo({
            top: el.offsetTop - 200,
            behavior: "smooth",
          });
        });
      }
    }
  }, [location, index]);

  return (
    <div className="general-page">
      <Header2 />
      <div className="page-container">
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default ScrollPage;